// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Professional Blue Sidebar --- */

/* Main Container */
.main-container {
  width: 100%;
  background: #f8fafc;
  min-height: 100vh;
}

/* Sidebar Container */
.sidebar {
  position: fixed;
  left: 0;
  top: 80px;
  width: 280px;
  height: calc(100vh - 80px);
  z-index: 1000;
  overflow-y: auto;
  background: var(--sidebar-gradient);
  box-shadow:
    1px 0 0 rgba(15, 23, 42, 0.06),
    4px 0 24px rgba(37, 99, 235, 0.14);
  transition: background 0.25s ease;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

/* BAInocular header actions (right side) */
.main-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.main-header-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease, opacity 0.15s ease;
}

.main-header-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.42);
}

.main-header-action-btn:active:not(:disabled) {
  transform: scale(0.96);
}

.main-header-action-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.9);
  outline-offset: 2px;
}

.main-header-action-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
}

/* Sidebar List */
.sidebar-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

/* Sidebar Section */
.sidebar-section {
  margin-bottom: 8px;
}

/* Main Section (AMS ProEn) */
.sidebar-section.main-section {
  margin-bottom: 0;
}

/* Main Content Container */
.main-content {
  padding-left: 0;
  margin-top: 5px;
}

/* Main Content Sections */
.main-content .sidebar-section {
  margin-left: 15px;
  margin-bottom: 6px;
}

.main-content .sidebar-section .section-header {
  margin: 0 5px 3px 5px;
  font-size: 12px;
  padding: 8px 12px;
}

/* Main Content Subsection Links */
.main-content .sidebar-item.subsection .sidebar-link {
  font-size: 12px;
  padding: 5px 15px 5px 20px;
  margin: 0 5px;
}

/* Main Content Link Icons */
.main-content .sidebar-item.subsection .sidebar-link .link-icon {
  color: rgba(255, 255, 255, 0.6);
  margin-right: 6px;
}

/* Active state for main content link icons */
.main-content .sidebar-item.subsection.active .sidebar-link .link-icon {
  color: var(--sidebar-active-text);
}

/* Hover state for main content link icons */  
.main-content .sidebar-item.subsection:hover .sidebar-link .link-icon {
  color: white;
}

/* Data Source Section */
.sidebar-section.data-source-section {
  margin-bottom: 5px;
  margin-left: 10px;
}

/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  font-weight: 600;
  font-size: 13px;
  color: white;
  /* text-transform: uppercase; */
  cursor: pointer;
  border: none;
  margin: 0 10px 5px 10px;
  transition: background 0.2s ease;
}

/* Main Header (AMS ProEn) */
.section-header.main-header {
  padding: 12px 15px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.18);
  margin: 0 10px 10px 10px;
}

/* Header Content */
.header-content {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
}

/* Section Icons */
.section-icon {
  color: rgba(255, 255, 255, 0.9);
  flex-shrink: 0;
}

/* Hover state for section icons */
.section-header:hover .section-icon {
  color: white;
}

/* Link Icons */
.link-icon {
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
  margin-right: 8px;
  display: flex;
  align-items: center;
}

/* Active state for link icons */
.sidebar-item.active .sidebar-link .link-icon {
  color: var(--sidebar-active-text);
}

/* Hover state for link icons */
.sidebar-link:hover .link-icon {
  color: white;
}
.section-header:hover {
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(15px);
}

.section-title {
  text-align: start;
  flex: 1 1;
}

.chevron-icon {
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease;
}
.section-header:hover .chevron-icon {
  color: white;
}

/* Sidebar Items */
.sidebar-item {
  margin: 0;
}

/* Sidebar Link */
.sidebar-link {
  display: flex;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  padding: 8px 15px;
  border-radius: 6px;
  background: transparent;
  transition: all 0.2s ease;
  outline: none;
  border: none;
  margin: 0 10px;
}

/* Hover State */
.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  backdrop-filter: blur(10px);
  transform: translateX(2px);
}

/* Active State */
.sidebar-item.active .sidebar-link {
  color: var(--sidebar-active-text);
  background: var(--sidebar-active-bg);
  font-weight: 600;
}

/* Subsection List */
.subsection-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background: transparent;
}

/* Subsection Items */
.sidebar-item.subsection .sidebar-link {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  background: transparent;
  margin: 0 10px;
  border-radius: 5px;
  padding: 6px 20px 6px 25px;
}
.sidebar-item.subsection.active > .sidebar-link {
  background: var(--sidebar-active-bg);
  color: var(--sidebar-active-text);
  font-weight: 600;
}
.sidebar-item.subsection:hover > .sidebar-link {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  backdrop-filter: blur(10px);
  transform: translateX(2px);
}

.sidebar-nested-group > .sidebar-link.nested-toggle {
  display: flex;
  align-items: center;
  width: calc(100% - 20px);
  box-sizing: border-box;
  cursor: pointer;
  font-family: inherit;
}

.sidebar-nested-group > .sidebar-link.nested-toggle .link-text {
  flex: 1 1;
  text-align: left;
}

.sidebar-nested-group > .sidebar-link.nested-toggle .chevron-icon {
  margin-left: 8px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.8);
}

.subsubsection-list {
  list-style: none;
  padding: 0 0 2px;
  margin: 0;
}

.sidebar-item.subsubsection .sidebar-link {
  display: flex;
  align-items: center;
  width: calc(100% - 20px);
  box-sizing: border-box;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  padding: 6px 16px 6px 47px;
  margin: 0 10px;
  border-radius: 5px;
}

.sidebar-item.subsubsection.active > .sidebar-link {
  background: var(--sidebar-active-bg);
  color: var(--sidebar-active-text);
  font-weight: 600;
}

.sidebar-item.subsubsection:hover > .sidebar-link {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  backdrop-filter: blur(10px);
}

/* Link Text */
.link-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 6px;
}
.sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

/* Responsive Design — drawer on mobile; desktop unchanged */
@media (max-width: 768px) {
  .sidebar {
    top: 64px;
    width: min(300px, 86vw);
    height: calc(100vh - 64px);
    height: calc(100dvh - 64px);
    z-index: 1100;
    transform: translateX(-105%);
    transition: transform 0.28s ease;
    padding-bottom: max(16px, env(safe-area-inset-bottom));
    box-shadow:
      1px 0 0 rgba(15, 23, 42, 0.08),
      12px 0 40px rgba(15, 23, 42, 0.28);
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .link-text {
    white-space: normal;
  }

  .main-content .sidebar-item.subsection .sidebar-link {
    padding: 8px 12px 8px 16px;
  }
}

/* --- End Professional Blue Sidebar --- */`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/styles.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,mBAAmB;AACnB;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC;;sCAEoC;EACpC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,oGAAoG;AACtG;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;AACnC;;AAEA,4CAA4C;AAC5C;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE;IACE,SAAS;IACT,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;IAChC,sDAAsD;IACtD;;wCAEoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,0CAA0C","sourcesContent":["/* --- Professional Blue Sidebar --- */\n\n/* Main Container */\n.main-container {\n  width: 100%;\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Sidebar Container */\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 80px;\n  width: 280px;\n  height: calc(100vh - 80px);\n  z-index: 1000;\n  overflow-y: auto;\n  background: var(--sidebar-gradient);\n  box-shadow:\n    1px 0 0 rgba(15, 23, 42, 0.06),\n    4px 0 24px rgba(37, 99, 235, 0.14);\n  transition: background 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0;\n}\n\n/* BAInocular header actions (right side) */\n.main-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.main-header-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.26);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.14);\n  color: rgba(255, 255, 255, 0.95);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease, opacity 0.15s ease;\n}\n\n.main-header-action-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.42);\n}\n\n.main-header-action-btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.main-header-action-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.9);\n  outline-offset: 2px;\n}\n\n.main-header-action-btn:disabled {\n  opacity: 0.38;\n  cursor: not-allowed;\n}\n\n/* Sidebar List */\n.sidebar-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n/* Sidebar Section */\n.sidebar-section {\n  margin-bottom: 8px;\n}\n\n/* Main Section (AMS ProEn) */\n.sidebar-section.main-section {\n  margin-bottom: 0;\n}\n\n/* Main Content Container */\n.main-content {\n  padding-left: 0;\n  margin-top: 5px;\n}\n\n/* Main Content Sections */\n.main-content .sidebar-section {\n  margin-left: 15px;\n  margin-bottom: 6px;\n}\n\n.main-content .sidebar-section .section-header {\n  margin: 0 5px 3px 5px;\n  font-size: 12px;\n  padding: 8px 12px;\n}\n\n/* Main Content Subsection Links */\n.main-content .sidebar-item.subsection .sidebar-link {\n  font-size: 12px;\n  padding: 5px 15px 5px 20px;\n  margin: 0 5px;\n}\n\n/* Main Content Link Icons */\n.main-content .sidebar-item.subsection .sidebar-link .link-icon {\n  color: rgba(255, 255, 255, 0.6);\n  margin-right: 6px;\n}\n\n/* Active state for main content link icons */\n.main-content .sidebar-item.subsection.active .sidebar-link .link-icon {\n  color: var(--sidebar-active-text);\n}\n\n/* Hover state for main content link icons */  \n.main-content .sidebar-item.subsection:hover .sidebar-link .link-icon {\n  color: white;\n}\n\n/* Data Source Section */\n.sidebar-section.data-source-section {\n  margin-bottom: 5px;\n  margin-left: 10px;\n}\n\n/* Section Header */\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  backdrop-filter: blur(10px);\n  font-weight: 600;\n  font-size: 13px;\n  color: white;\n  /* text-transform: uppercase; */\n  cursor: pointer;\n  border: none;\n  margin: 0 10px 5px 10px;\n  transition: background 0.2s ease;\n}\n\n/* Main Header (AMS ProEn) */\n.section-header.main-header {\n  padding: 12px 15px;\n  font-size: 14px;\n  background: rgba(255, 255, 255, 0.18);\n  margin: 0 10px 10px 10px;\n}\n\n/* Header Content */\n.header-content {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 8px;\n}\n\n/* Section Icons */\n.section-icon {\n  color: rgba(255, 255, 255, 0.9);\n  flex-shrink: 0;\n}\n\n/* Hover state for section icons */\n.section-header:hover .section-icon {\n  color: white;\n}\n\n/* Link Icons */\n.link-icon {\n  color: rgba(255, 255, 255, 0.7);\n  flex-shrink: 0;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n}\n\n/* Active state for link icons */\n.sidebar-item.active .sidebar-link .link-icon {\n  color: var(--sidebar-active-text);\n}\n\n/* Hover state for link icons */\n.sidebar-link:hover .link-icon {\n  color: white;\n}\n.section-header:hover {\n  background: rgba(255, 255, 255, 0.18);\n  backdrop-filter: blur(15px);\n}\n\n.section-title {\n  text-align: start;\n  flex: 1;\n}\n\n.chevron-icon {\n  color: rgba(255, 255, 255, 0.8);\n  transition: color 0.2s ease;\n}\n.section-header:hover .chevron-icon {\n  color: white;\n}\n\n/* Sidebar Items */\n.sidebar-item {\n  margin: 0;\n}\n\n/* Sidebar Link */\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 15px;\n  border-radius: 6px;\n  background: transparent;\n  transition: all 0.2s ease;\n  outline: none;\n  border: none;\n  margin: 0 10px;\n}\n\n/* Hover State */\n.sidebar-link:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  backdrop-filter: blur(10px);\n  transform: translateX(2px);\n}\n\n/* Active State */\n.sidebar-item.active .sidebar-link {\n  color: var(--sidebar-active-text);\n  background: var(--sidebar-active-bg);\n  font-weight: 600;\n}\n\n/* Subsection List */\n.subsection-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n}\n\n/* Subsection Items */\n.sidebar-item.subsection .sidebar-link {\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n  background: transparent;\n  margin: 0 10px;\n  border-radius: 5px;\n  padding: 6px 20px 6px 25px;\n}\n.sidebar-item.subsection.active > .sidebar-link {\n  background: var(--sidebar-active-bg);\n  color: var(--sidebar-active-text);\n  font-weight: 600;\n}\n.sidebar-item.subsection:hover > .sidebar-link {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  backdrop-filter: blur(10px);\n  transform: translateX(2px);\n}\n\n.sidebar-nested-group > .sidebar-link.nested-toggle {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 20px);\n  box-sizing: border-box;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.sidebar-nested-group > .sidebar-link.nested-toggle .link-text {\n  flex: 1;\n  text-align: left;\n}\n\n.sidebar-nested-group > .sidebar-link.nested-toggle .chevron-icon {\n  margin-left: 8px;\n  flex-shrink: 0;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.subsubsection-list {\n  list-style: none;\n  padding: 0 0 2px;\n  margin: 0;\n}\n\n.sidebar-item.subsubsection .sidebar-link {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 20px);\n  box-sizing: border-box;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n  padding: 6px 16px 6px 47px;\n  margin: 0 10px;\n  border-radius: 5px;\n}\n\n.sidebar-item.subsubsection.active > .sidebar-link {\n  background: var(--sidebar-active-bg);\n  color: var(--sidebar-active-text);\n  font-weight: 600;\n}\n\n.sidebar-item.subsubsection:hover > .sidebar-link {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  backdrop-filter: blur(10px);\n}\n\n/* Link Text */\n.link-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Scrollbar Styling */\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n.sidebar::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 3px;\n}\n\n/* Responsive Design — drawer on mobile; desktop unchanged */\n@media (max-width: 768px) {\n  .sidebar {\n    top: 64px;\n    width: min(300px, 86vw);\n    height: calc(100vh - 64px);\n    height: calc(100dvh - 64px);\n    z-index: 1100;\n    transform: translateX(-105%);\n    transition: transform 0.28s ease;\n    padding-bottom: max(16px, env(safe-area-inset-bottom));\n    box-shadow:\n      1px 0 0 rgba(15, 23, 42, 0.08),\n      12px 0 40px rgba(15, 23, 42, 0.28);\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .link-text {\n    white-space: normal;\n  }\n\n  .main-content .sidebar-item.subsection .sidebar-link {\n    padding: 8px 12px 8px 16px;\n  }\n}\n\n/* --- End Professional Blue Sidebar --- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
